export const TimeKeepingEN = {
    "timeSheet": "Time Sheet",
    "shiftSchedule": "Shift Schedule",
    "shiftAssignment": "Shift Assignment",
    "meals": "Meals",
    "leaveManagement": "Leave Management",
    "autoInout": "Auto Inout",
    "casualAndCompensatory": "Casual And Compensatory",
    "casualLeave": "Casual Leave",
    "compensatoryLeave": "Compensatory Leave",

    keyword: {
        "POS_TONG_DT_GOP_CTY": "Total gross revenue of the company",
        "POS_TONG_DT_THUAN_CTY": "Total net revenue of the company",
        "POS_TONG_LN_GOP_CTY": "Total gross profit of the company",
        "POS_TONG_DT_GOP_NV": "Total gross revenue of the employee",
        "POS_TONG_DT_THUAN_NV": "Total net revenue of the employee",
        "POS_TONG_TIEN_HOA_HONG_NV": "Total commission of the employee",
        "POS_TONG_SO_SP_BAN_RA_NV": "Total number of products sold",
        "POS_TONG_SO_SP_HOAN_THANH_NV": "Total number of completed products",
        "POS_TONG_SO_DH_BAN_RA_NV": "Total number of orders sold",
        "POS_TONG_SO_DH_HOAN_THANH_NV": "Total number of completed orders",
        "POS_TONG_SO_KH_MOI_NV": "Total number of new customers",
        "POS_TONG_SO_KH_MOI_HOAN_THANH_NV": "Total number of completed new customers",
        "POS_SALE_PLAN_ACHIEVEMENT": "Sale Plan achievement rate",

        "currentYear": " for the current year",
        "currentMonth": " for the current month",
        "currentQuarter": " for the current quarter",

        "doWork_task_completed": "Total number of completed tasks",
        "doWork_task_late": "Total number of overdue tasks (including both incomplete and completed)",
        "doWork_task_ontime": "Total number of tasks completed on time",
        "doWork_task_early": "Total number of tasks completed ahead of schedule",
        "doWork_task_pending": "Total number of unfinished tasks (both not started and incomplete)",
        "doWork_task_in_progress": "Number of tasks in progress but not yet completed",
        "doWork_task_in_overdue_incomplete": "Number of overdue tasks that are not yet completed",
        "doWork_product_target": "Target number of products to be completed (initial quota)",
        "doWork_product_quantity": "Total number of products completed",
        "doWork_product_remaining": "Remaining number of products (not completed)",

        "totalTaskLabel": "Total number of tasks with label {{name}}",
        "totalTaskLabelAndStatus": "Total number of tasks with label {{name}} and status {{status}}",

        "UNION": "Union Fee",
        "NUMBER_RELATION": "Number of Dependents",
        "GROSS_INCOME": "Gross Income",
        "ASSESSABLE_INCOME": "Assessable Income",
        "TAXABLE_INCOME": "Taxable Income",
        "PIT": "Personal Income Tax",
        "UNION_EMPLOYER": "Employer's Union Fee",
        "DEDUCT_INSURANCE": "Deducted Social, Health, Unemployment Insurance",
        "KPI_MONTH": "KPI Score for the Month",
        "SALARY_END": "Total Salary",
        "SALARY_ENTERPRISE": "Salary Transferred to Enterprise Account",
        "SALARY_PRIVATE": "Salary Transferred to Personal Account",
        "SALARY_PAID": "Paid Salary",
        "SALARY_REST": "Unpaid Salary",

        // SHIFTS

        "THU_TRONG_TUAN_NOTE": "Day of the week being calculated",
        "THU_TRONG_TUAN": "Day of the week",
        "NGAY_NGHI_LE_EXAMPLE": "0|1",
        "NGAY_NGHI_LE_NOTE": "Returns 1 if the shift falls on a public holiday, 0 otherwise",
        "NGAY_NGHI_LE": "Public holiday",
        "NGAY_NGHI_TUAN_EXAMPLE": "0|1",
        "NGAY_NGHI_TUAN_NOTE": "Returns 1 if the shift falls on a weekly rest day, 0 otherwise",
        "NGAY_NGHI_TUAN": "Weekly rest day",
        "CA_CHINH_EXAMPLE": "0|1",
        "CA_CHINH_NOTE": "Returns 1 if the shift is a main shift (not an additional shift from a request), 0 otherwise",
        "CA_CHINH": "Main shift or not",
        "CA_TU_DONG_EXAMPLE": "0|1",
        "CA_TU_DONG_NOTE": "Returns 1 if the shift is automatically assigned, 0 otherwise",
        "CA_TU_DONG": "Automatically assigned shift",
        "CHAM_CONG_TRUC_TIEP_NGAY_EXAMPLE": "0|1",
        "CHAM_CONG_TRUC_TIEP_NGAY_NOTE": "Returns 1 if the attendance is direct and not calculated, 0 otherwise for that day",
        "CHAM_CONG_TRUC_TIEP_NGAY": "Direct attendance tracking by day",
        "CA_QUA_NGAY_EXAMPLE": "0|1",
        "CA_QUA_NGAY_NOTE": "Returns 1 if the shift spans across days, 0 otherwise",
        "CA_QUA_NGAY": "Shift spanning multiple days",
        "CA_TU_DONG_CHAM_CONG_EXAMPLE": "0|1",
        "CA_TU_DONG_CHAM_CONG_NOTE": "Returns 1 if the shift is automatically recorded, 0 otherwise",
        "CA_TU_DONG_CHAM_CONG": "Automatically recorded shift",
        "CA_TU_DONG_CHECKOUT_EXAMPLE": "0|1",
        "CA_TU_DONG_CHECKOUT_NOTE": "Returns 1 if the shift is automatically checked out, 0 otherwise",
        "CA_TU_DONG_CHECKOUT": "Automatically checked-out shift",
        "CA_BAT_BUOC_CHOT_GIUA_CA_EXAMPLE": "0|1",
        "CA_BAT_BUOC_CHOT_GIUA_CA_NOTE": "Returns 1 if the shift requires mid-shift confirmation, 0 otherwise",
        "CA_BAT_BUOC_CHOT_GIUA_CA": "Shift requiring mid-shift confirmation",
        "CA_ID_EXAMPLE": "1",
        "CA_ID_NOTE": "Returns the shift ID",
        "CA_ID": "Shift ID",
        "CA_MA_EXAMPLE": "HC1",
        "CA_MA_NOTE": "Returns the shift code",
        "CA_MA": "Shift code",
        "CA_TEN_EXAMPLE": "Administrative 1",
        "CA_TEN_NOTE": "Returns the shift name",
        "CA_TEN": "Shift name",
        "NGAY": "Shift assignment date",
        "THOI_GIAN_BAT_DAU_CA": "Shift start date and time",
        "THOI_GIAN_KET_THUC_CA": "Shift end date and time",
        "GIO_BAT_DAU_CA": "Shift start date and time",
        "GIO_KET_THUC_CA": "Shift end date and time",
        "GIO_BAT_DAU_NGHI": "Break start time",
        "GIO_KET_THUC_NGHI_EXAMPLE": "10/09/2021",
        "GIO_KET_THUC_NGHI": "Break end time",
        "TONG_SO_GIO_CA_EXAMPLE": "7.5h",
        "TONG_SO_GIO_CA_NOTE": "Returns the total working hours of the shift",
        "TONG_SO_GIO_CA": "Total shift working hours",
        "TONG_SO_CONG_CA_EXAMPLE": "0.5",
        "TONG_SO_CONG_CA_NOTE": "Total work units of the shift",
        "TONG_SO_CONG_CA": "Total work units of the shift",
        "GIO_LAM_VIEC_THUC_TE_EXAMPLE": "0.6",
        "GIO_LAM_VIEC_THUC_TE_NOTE": "Actual working hours recorded for the day",
        "GIO_LAM_VIEC_THUC_TE": "Actual working hours recorded in the day",
        "GIO_LAM_VIEC_GIUA_CA_EXAMPLE": "0.7",
        "GIO_LAM_VIEC_GIUA_CA_NOTE": "Hours worked during the mid-shift break",
        "GIO_LAM_VIEC_GIUA_CA": "Hours worked during mid-shift break",
        "GIO_LAM_VIEC_DEM_EXAMPLE": "0.8",
        "GIO_LAM_VIEC_DEM_NOTE": "Actual night shift working hours",
        "GIO_LAM_VIEC_DEM": "Actual night shift working hours",
        "GIO_LAM_VIEC_NGAY_EXAMPLE": "0.9",
        "GIO_LAM_VIEC_NGAY_NOTE": "Actual day shift working hours",
        "GIO_LAM_VIEC_NGAY": "Actual day shift working hours",
        "SO_GIO_LAM_VIEC_EXAMPLE": "0.1",
        "SO_GIO_LAM_VIEC_NOTE": "Total hours worked in the shift",
        "SO_GIO_LAM_VIEC": "Total hours worked in the shift",
        "SO_CONG_LAM_VIEC_EXAMPLE": "0.11",
        "SO_CONG_LAM_VIEC_NOTE": "The number of working days calculated in a day",
        "SO_CONG_LAM_VIEC": "Number of working days in a shift",
        "SO_GIO_NGHI_BU_EXAMPLE": "0.12",
        "SO_GIO_NGHI_BU_NOTE": "Number of compensatory leave hours in a shift",
        "SO_GIO_NGHI_BU": "Compensatory leave hours in a shift",
        "SO_GIO_TINH_DON_CHE_DO_EXAMPLE": "0.13",
        "SO_GIO_TINH_DON_CHE_DO_NOTE": "Number of hours counted for special leave in a shift",
        "SO_GIO_TINH_DON_CHE_DO": "Hours counted for special leave in a shift",
        "CHECKIN_EXAMPLE": "2022-05-09 07:30:00",
        "CHECKIN_NOTE": "Returns the check-in time in a shift in date-time format",
        "CHECKIN": "Check-in time in a shift",
        "CHECKOUT_EXAMPLE": "2022-05-09 17:35:00",
        "CHECKOUT_NOTE": "Returns the check-out time in a shift in date-time format",
        "CHECKOUT": "Check-out time in a shift",
        "GIO_CHECKIN_EXAMPLE": "07:30:00",
        "GIO_CHECKIN_NOTE": "Returns the check-in time in a shift in time format",
        "GIO_CHECKIN": "Check-in time in a shift",
        "GIO_CHECKOUT_EXAMPLE": "17:35:00",
        "GIO_CHECKOUT_NOTE": "Returns the check-out time in a shift in time format",
        "GIO_CHECKOUT": "Check-out time in a shift",
        "SO_GIO_VANG_MAT": "Number of unpaid absent hours",
        "SO_PHUT_DI_MUON_EXAMPLE": "30",
        "SO_PHUT_DI_MUON_NOTE": "Number of minutes late in a day",
        "SO_PHUT_DI_MUON": "Minutes late",
        "SO_PHUT_VE_SOM_EXAMPLE": "20",
        "SO_PHUT_VE_SOM_NOTE": "Number of minutes leaving early in a day",
        "SO_PHUT_VE_SOM": "Minutes leaving early",
        "SO_NGAY_NGHI_EXAMPLE": "0.5",
        "SO_NGAY_NGHI_NOTE": "Number of leave days in a shift",
        "SO_NGAY_NGHI": "Number of leave days",
        "GHI_CHU_NOTE": "Notes in a shift",
        "GHI_CHU": "Notes",
        "SO_NGAY_NGHI_PHEP_EXAMPLE": "0.5",
        "SO_NGAY_NGHI_PHEP_NOTE": "Number of paid leave days",
        "SO_NGAY_NGHI_PHEP": "Paid leave days",
        "SO_NGAY_NGHI_KHONG_LY_DO_EXAMPLE": "0.5",
        "SO_NGAY_NGHI_KHONG_LY_DO_NOTE": "Number of unauthorized leave days",
        "SO_NGAY_NGHI_KHONG_LY_DO": "Unauthorized leave days",
        "KHONG_CHECKIN_EXAMPLE": "0|1",
        "KHONG_CHECKIN_NOTE": "Returns 1 if check-in is missing, 0 otherwise",
        "KHONG_CHECKIN": "Missing check-in",
        "KHONG_CHECKOUT_EXAMPLE": "0|1",
        "KHONG_CHECKOUT_NOTE": "Returns 1 if check-out is missing, 0 otherwise",
        "KHONG_CHECKOUT": "Missing check-out",
        "KHONG_CHECKINOUT_EXAMPLE": "0|1",
        "KHONG_CHECKINOUT_NOTE": "Returns 1 if check-in or check-out is missing, 0 otherwise",
        "KHONG_CHECKINOUT": "Missing check-in/out",
        "NGAY_CONG_TAC": "Has a business trip request",
        "KY_HIEU_NGHI_EXAMPLE": "1",
        "KY_HIEU_NGHI_NOTE": "Leave request symbols, separated by commas",
        "KY_HIEU_NGHI": "Leave symbols",
        "DU_LIEU_NGHI_EXAMPLE": "1",
        "DU_LIEU_NGHI_NOTE": "{P:1,N:1}",
        "DU_LIEU_NGHI": "Leave data",
        "NGUON_CHOT_VAN_TAY_EXAMPLE": "NO_FINGER",
        "NGUON_CHOT_VAN_TAY_NOTE": "NO_FINGER: Forgot check-in/out, FAIL_MACHINE: Attendance machine failure, MISSION: Work-related reason or business trip",
        "NGUON_CHOT_VAN_TAY": "Fingerprint check-in/out source",
        "SO_LAN_QUEN_CHAM_CONG_EXAMPLE": "1",
        "SO_LAN_QUEN_CHAM_CONG_NOTE": "Returns the number of times check-in/out was missed in a shift",
        "SO_LAN_QUEN_CHAM_CONG": "Number of missed check-ins/outs",
        "PHEP_SO_GIO_TINH_CONG_EXAMPLE": "3.5",
        "PHEP_SO_GIO_TINH_CONG_NOTE": "Total hours counted for payroll from leave requests in a shift",
        "PHEP_SO_GIO_TINH_CONG": "Paid hours from leave requests",
        "PHEP_SO_CONG_TINH_CONG_EXAMPLE": "3.5",
        "PHEP_SO_CONG_TINH_CONG": "Paid workdays from leave requests",
        "PHEP_SO_GIO_KHONG_TINH_CONG_EXAMPLE": "4",
        "PHEP_SO_GIO_KHONG_TINH_CONG_NOTE": "Total hours not counted for payroll from leave requests in a shift",
        "PHEP_SO_GIO_KHONG_TINH_CONG": "Unpaid hours from leave requests",
        "PHEP_SO_CONG_KHONG_TINH_CONG_EXAMPLE": "4",
        "PHEP_SO_CONG_KHONG_TINH_CONG": "Unpaid workdays from leave requests",
        "CONG_TAM_UNG_EXAMPLE": "1",
        "CONG_TAM_UNG_NOTE": "Returns the number of advanced workdays",
        "CONG_TAM_UNG": "Advanced workdays",
        "LOAI_HOP_DONG_ID_EXAMPLE": "1",
        "LOAI_HOP_DONG_ID": "Contract type ID",
        "LOAI_HOP_DONG_EXAMPLE": "THOIHAN",
        "LOAI_HOP_DONG_NOTE": "Employee contract type. Includes: 0,1",
        "LOAI_HOP_DONG": "Contract type",
        "CONG_LAM_VIEC_EXAMPLE": "1",
        "CONG_LAM_VIEC_NOTE": "Workday calculation formula for a shift",
        "CONG_LAM_VIEC": "Workdays",
        "GIO_LAM_VIEC_NOTE": "Actual working hours",
        "GIO_LAM_VIEC": "Actual working hours",
        "CONG_AN_NOTE": "Meal compensation calculation formula for a shift",
        "CONG_AN": "Meal compensation",
        "TIEN_PHAT_DI_MUON_EXAMPLE": "1",
        "TIEN_PHAT_DI_MUON_NOTE": "Late arrival penalty calculation formula",
        "TIEN_PHAT_DI_MUON": "Late arrival penalty",
        "TIEN_PHAT_VE_SOM_EXAMPLE": "1",
        "TIEN_PHAT_VE_SOM_NOTE": "Early leave penalty calculation formula",
        "TIEN_PHAT_VE_SOM": "Early leave penalty",
        "TIEN_PHAT_NGHI_KHONG_LY_DO_EXAMPLE": "1",
        "TIEN_PHAT_NGHI_KHONG_LY_DO_NOTE": "Unauthorized leave penalty calculation formula",
        "TIEN_PHAT_NGHI_KHONG_LY_DO": "Unauthorized leave penalty",
        "TIEN_PHAT_KHONG_CHECKINOUT_EXAMPLE": "1",
        "TIEN_PHAT_KHONG_CHECKINOUT_NOTE": "Check-in/out missing penalty calculation formula",
        "TIEN_PHAT_KHONG_CHECKINOUT": "Check-in/out missing penalty",
        "CONG_PHAT_DI_MUON": "Workday deduction for late arrival",
        "CONG_PHAT_VE_SOM": "Workday deduction for early leave",
        "CONG_PHAT_NGHI_KHONG_LY_DO": "Workday deduction for unauthorized leave",
        "CONG_PHAT_KHONG_CHECKINOUT": "Workday deduction for missing check-in/out",
        "CA_DUOC_PHAN": "Assigned shift",
        "LOAI_CA": "Assigned shift type (Administrative - Shift work)",
        "DONG_TANG_CA": "Overtime request",
        "CHI_TIET_DON_TANG_CA": "Overtime request details",
        "LOAI_TINH_CONG": "Overtime counted as compensatory leave or work hours",
// #DATES
        "NGAY_EXAMPLE": "10/09/2021",
        "NGAY_NOTE": "Date being calculated",
        "TRANG_THAI_LAM_VIEC_EXAMPLE": "WORKING",
        "TRANG_THAI_LAM_VIEC_NOTE": "Returns the employee's work status for the day. WORKING = working, LEAVING = maternity leave, STOP_WORKING = resigned",
        "TRANG_THAI_LAM_VIEC": "Work status",
        "CHAM_CONG_TRUC_TIEP_EXAMPLE": "0|1",
        "CHAM_CONG_TRUC_TIEP_NOTE": "Returns 1 if attendance is recorded directly without calculation, 0 otherwise",
        "CHAM_CONG_TRUC_TIEP": "Direct attendance recording",
        "SO_LAN_DI_MUON_NOTE": "Number of late arrivals in the day",
        "SO_LAN_DI_MUON": "Number of late arrivals",
        "SO_LAN_VE_SOM_NOTE": "Number of early departures in the day",
        "SO_LAN_VE_SOM": "Number of early departures",
        "NGAY_NGHI_BU_SU_KIEN_EXAMPLE": "01",
        "NGAY_NGHI_BU_SU_KIEN_NOTE": "Returns 1 if there is compensatory leave or event leave, 0 otherwise",
        "NGAY_NGHI_BU_SU_KIEN": "Compensatory leave or event leave",
        "NGAY_CONG_TAC_EXAMPLE": "0|1",
        "GIO_CONG_TAC_EXAMPLE": "0|8",
        "GIO_CONG_TAC": "Working hours on a business trip",
        "PHU_PHI_CONG_TAC_EXAMPLE": "100000",
        "PHU_PHI_CONG_TAC": "Business trip allowance",
        "TONG_SO_CA_EXAMPLE": "1",
        "TONG_SO_CA_NOTE": "Total shifts worked in the day",
        "TONG_SO_CA": "Total shifts",
        "SO_CONG_NGHI_LE_NOTE": "Work units counted for public holidays, compensatory leave, or events",
        "SO_CONG_NGHI_LE": "Work units on holidays",
        "SO_GIO_NGHI_LE_NOTE": "Hours counted for public holidays, compensatory leave, or events",
        "SO_GIO_NGHI_LE": "Hours on holidays",
        "NGAY_KHONG_LAM_VIEC_EXAMPLE": "0|1",
        "NGAY_KHONG_LAM_VIEC_NOTE": "Returns 0 if it's a working day (assigned shift, weekly off, or holiday), 1 otherwise",
        "NGAY_KHONG_LAM_VIEC": "Non-working day",
        "CONG_LAM_VIEC_CA": "Work units per shift",
        "GIO_LAM_VIEC_CA": "Actual working hours per shift",
        "CONG_NGHI_LE": "Work units on holidays",
        "GIO_NGHI_LE": "Working hours on holidays",
        "CONG_AN_THEM": "Additional work units in the day",
        "CONG_LAM_THEM": "Overtime work units in the day",
        "CONG_LAM_THEM_THUC_TE": "Actual overtime work units in the day",
        "GIO_LAM_THEM": "Overtime hours in the day",
        "GIO_LAM_THEM_THUC_TE": "Actual overtime hours",
        "CONG_LAM_THEM_DEM_NOTE": "Work units for night overtime hours",
        "CONG_LAM_THEM_DEM": "Night overtime work units",
        "CONG_LAM_THEM_THUC_TE_DEM_NOTE": "Actual work units for night overtime",
        "CONG_LAM_THEM_THUC_TE_DEM": "Actual night overtime work units",
        "GIO_LAM_THEM_DEM": "Night overtime hours",
        "GIO_LAM_THEM_THUC_TE_DEM": "Actual night overtime hours",
        "GIO_LAM_THEM_NGAY_NGHI_LE": "Overtime hours on public holidays",
        "GIO_LAM_THEM_NGAY_NGHI_TUAN": "Overtime hours on weekly days off",
        "GIO_LAM_THEM_NGAY_DI_LAM": "Overtime hours on working days",
        "CONG_CONG_TAC": "Business trip work units",
        "GHI_CHU_NGAY_NOTE": "Daily attendance sheet notes",
        "GHI_CHU_NGAY": "Notes",
        "NGAY_LAM_THEM_HOM_TRUOC_EXAMPLE": "0|1",
        "NGAY_LAM_THEM_HOM_TRUOC_NOTE": "0: Returns the previous day without overtime, 1: The previous day had overtime",
        "NGAY_LAM_THEM_HOM_TRUOC": "Overtime on the previous day",
        "NGAY_DI_LAM_EXAMPLE": "1|0",
        "NGAY_DI_LAM_NOTE": "1: Worked that day, 0: Absent, weekend off, leave, holiday",
        "NGAY_DI_LAM": "Worked or not",
        "CONG_THUC_TE_EXAMPLE": "1",
        "CONG_THUC_TE_NOTE": "Returns the actual working days, excluding leave records",
        "CONG_THUC_TE": "Actual working days",
        "CHOT_DAU_TIEN_NOTE": "First confirmation",
        "CHOT_DAU_TIEN": "First confirmation",
        "CHOT_CUOI_CUNG_NOTE": "Final confirmation",
        "CHOT_CUOI_CUNG": "Final confirmation",

        //Overtimes
        "DEM_EXAMPLE": "0|1",
        "DEM": "Night shift",
        "THU_TRONG_TUAN_EXAMPLE": "2,3,4,5,6,7,8",
        "NGAY_LAM_THEM_HOM_TRUOC_LOAI_EXAMPLE": "NORMAL|HOLIDAY|DAYOFF",
        "NGAY_LAM_THEM_HOM_TRUOC_LOAI_NOTE": "NORMAL is a working day, DAYOFF is a day off, HOLIDAY is a holiday",
        "NGAY_LAM_THEM_HOM_TRUOC_LOAI": "Previous day was a normal day or a holiday",
        "NGAY_LAM_THEM_HOM_TRUOC_THOI_GIAN_BAT_DAU_EXAMPLE": "17:30",
        "NGAY_LAM_THEM_HOM_TRUOC_THOI_GIAN_BAT_DAU": "Overtime start time on the previous day",
        "NGAY_LAM_THEM_HOM_TRUOC_THOI_GIAN_KET_THUC_EXAMPLE": "19:30",
        "NGAY_LAM_THEM_HOM_TRUOC_THOI_GIAN_KET_THUC": "Overtime end time on the previous day",
        "GIO_LAM_BU_THUC_TE_NOTE": "Actual compensated working hours",
        "GIO_LAM_BU_THUC_TE": "Actual compensated working hours",
        "GIO_LAM_THEM_ID": "Overtime record ID",

        //Month
        "ID_EXAMPLE": "99",
        "ID_NOTE": "Returns the system ID of the employee",
        "ID": "ID",
        "MA_NHAN_SU_EXAMPLE": "1234",
        "MA_NHAN_SU_NOTE": "Returns the employee profile code",
        "MA_NHAN_SU": "Employee Code",
        "HO_TEN_EXAMPLE": "Nguyen Van A",
        "HO_TEN_NOTE": "Returns the employee's name",
        "HO_TEN": "Full Name",
        "MA_HOP_DONG_EXAMPLE": "1368_01",
        "MA_HOP_DONG_NOTE": "Returns the employee's contract code",
        "MA_HOP_DONG": "Contract Code",
        "MA_CHAM_CONG_EXAMPLE": "1234",
        "MA_CHAM_CONG_NOTE": "Returns the employee's system attendance code",
        "MA_CHAM_CONG": "Attendance Code",
        "SO_BHXH_EXAMPLE": "1221",
        "SO_BHXH_NOTE": "Returns the employee's social insurance number",
        "SO_BHXH": "Social Insurance Number",
        "SO_THE_BHYT_EXAMPLE": "835323….",
        "SO_THE_BHYT_NOTE": "Returns the employee's health insurance card number",
        "SO_THE_BHYT": "Health Insurance Card Number",
        "VI_TRI_EXAMPLE": "Store Employee",
        "VI_TRI_NOTE": "Returns the employee's position title",
        "VI_TRI": "Position",
        "SO_NGUOI_PHU_THUOC_EXAMPLE": "2",
        "SO_NGUOI_PHU_THUOC_NOTE": "Returns the number of dependents",
        "SO_NGUOI_PHU_THUOC": "Number of Dependents",
        "VI_TRI_ID_NOTE": "Returns the employee's position ID",
        "VI_TRI_ID": "Position ID",
        "CHUC_VU_EXAMPLE": "Business Director",
        "CHUC_VU_NOTE": "Returns the employee's job title",
        "CHUC_VU": "Job Title",
        "CHUC_DANH_ID_NOTE": "Returns the employee's job title ID",
        "CHUC_DANH_ID": "Job Title ID",
        "MA_PHONG_BAN_EXAMPLE": "PB01",
        "MA_PHONG_BAN_NOTE": "Employee's department code",
        "MA_PHONG_BAN": "Department Code",
        "TEN_PHONG_BAN_EXAMPLE": "Business 2",
        "TEN_PHONG_BAN_NOTE": "Employee's department name",
        "TEN_PHONG_BAN": "Department Name",
        "TEN_PHONG_BAN_DAY_DU_EXAMPLE": "Company A/Business 2",
        "TEN_PHONG_BAN_DAY_DU_NOTE": "Employee's full department name",
        "TEN_PHONG_BAN_DAY_DU": "Full Department Name",
        "TEN_PHONG_BAN_CHINH_EXAMPLE": "Business 2",
        "TEN_PHONG_BAN_CHINH_NOTE": "Employee's main department name",
        "TEN_PHONG_BAN_CHINH": "Main Department Name",
        "PHONG_BAN_ID_EXAMPLE": "Business 2",
        "PHONG_BAN_ID_NOTE": "Employee's system department ID",
        "PHONG_BAN_ID": "Department ID",
        "CHI_NHANH_ID_EXAMPLE": "Branch 1",
        "CHI_NHANH_ID_NOTE": "Employee's system branch ID",
        "CHI_NHANH_ID": "Branch ID",
        "CHI_NHANH_TEN_EXAMPLE": "Branch 1",
        "CHI_NHANH_TEN_NOTE": "Employee's branch name",
        "CHI_NHANH_TEN": "Branch Name",
        "CONG_TY_ID_EXAMPLE": "Company",
        "CONG_TY_ID_NOTE": "Employee's company ID",
        "CONG_TY_ID": "Company ID",
        "CONG_TY_TEN_EXAMPLE": "Company",
        "CONG_TY_TEN_NOTE": "Employee's company name",
        "CONG_TY_TEN": "Company Name",
        "NGAY_NGHI_VIEC_NOTE": "Employee's resignation date",
        "NGAY_NGHI_VIEC": "Resignation Date",
        "GIOI_TINH_EXAMPLE": "Male|Female|Other",
        "GIOI_TINH_NOTE": "Employee's gender",
        "GIOI_TINH": "Gender",
        "EMAIL_NOTE": "Employee's email",
        "EMAIL": "Email",
        "NGAY_SINH_NOTE": "Employee's date of birth",
        "NGAY_SINH": "Date of Birth",
        "DIEN_THOAI_NOTE": "Employee's phone number",
        "DIEN_THOAI": "Phone Number",
        "QUOC_TICH_NOTE": "Employee's nationality",
        "QUOC_TICH": "Nationality",
        "TEN_TAI_KHOAN_NGAN_HANG_NOTE": "Employee's bank account name",
        "TEN_TAI_KHOAN_NGAN_HANG": "Bank Account Name",
        "MA_SO_THUE_CA_NHAN_NOTE": "Employee's personal tax code",
        "MA_SO_THUE_CA_NHAN": "Personal Tax Code",
        "SO_TAI_KHOAN_NGAN_HANG_NOTE": "Employee's bank account number",
        "SO_TAI_KHOAN_NGAN_HANG": "Bank Account Number",
        "TEN_NGAN_HANG_NOTE": "Employee's bank name",
        "TEN_NGAN_HANG": "Bank Name",
        "TEN_NGAN_HANG_QUOC_TE_NOTE": "Employee's international bank name",
        "TEN_NGAN_HANG_QUOC_TE": "International Bank Name",
        "NGAN_HANG_ID_NOTE": "Returns the employee's bank ID",
        "NGAN_HANG_ID": "Bank ID",
        "NGAN_HANG_CODE_NOTE": "Employee's bank code",
        "NGAN_HANG_CODE": "Bank Code",
        "NGAN_HANG_CHI_NHANH_NOTE": "Bank branch name of the employee",
        "NGAN_HANG_CHI_NHANH": "Bank branch",
        "NOI_LAM_VIEC_EXAMPLE": "0|1",
        "NOI_LAM_VIEC_NOTE": "Workplace of the employee",
        "NOI_LAM_VIEC": "Workplace",
        "KHONG_YEU_CAU_CHOT_CONG_EXAMPLE": "0|1",
        "KHONG_YEU_CAU_CHOT_CONG_NOTE": "Returns 1 if fingerprint check-in is not required, 0 otherwise",
        "KHONG_YEU_CAU_CHOT_CONG": "No fingerprint check-in required",
        "SO_CONG_CHUAN_TU_DONG_EXAMPLE": "23",
        "SO_CONG_CHUAN_TU_DONG_NOTE": "Returns the standard workdays of the employee according to the position",
        "SO_CONG_CHUAN_TU_DONG": "Automatically calculated standard workdays",
        "SO_CONG_CHUAN_EXAMPLE": "5000000",
        "SO_CONG_CHUAN_NOTE": "Returns the standard workdays according to the set formula",
        "SO_CONG_CHUAN": "Standard workdays based on custom formula",
        "LUONG_VI_TRI_EXAMPLE": "3210000",
        "LUONG_VI_TRI_NOTE": "Returns the position salary of the employee",
        "LUONG_VI_TRI": "Position salary",
        "LUONG_BHXH_NOTE": "Returns the social insurance salary of the employee",
        "LUONG_BHXH": "Social insurance salary",
        "LUONG_PHU_CAP_NOTE": "Returns the employee’s allowance salary",
        "LUONG_PHU_CAP": "Allowance salary",
        "LUONG_PHU_CAP_TINH_THUE_EXAMPLE": "11000000",
        "LUONG_PHU_CAP_TINH_THUE_NOTE": "Returns the taxable allowance salary of the employee",
        "LUONG_PHU_CAP_TINH_THUE": "Taxable allowance salary",
        "LUONG_PHU_CAP_KHONG_TINH_THUE_EXAMPLE": "4400000",
        "LUONG_PHU_CAP_KHONG_TINH_THUE_NOTE": "Returns the non-taxable allowance salary of the employee",
        "LUONG_PHU_CAP_KHONG_TINH_THUE": "Non-taxable allowance salary",
        "GIAM_TRU_CA_NHAN_NOTE": "Returns the employee’s personal deduction",
        "GIAM_TRU_CA_NHAN": "Personal deduction",
        "GIAM_THUE_1_NGUOI_PHU_THUOC_NOTE": "Returns the tax exemption amount for one dependent",
        "GIAM_THUE_1_NGUOI_PHU_THUOC": "Tax exemption for one dependent",
        "NGAY_VAO_NOTE": "Returns the employee’s joining date",
        "NGAY_VAO": "Joining date",
        "NGAY_VAO_CHINH_THUC_NOTE": "Returns the official joining date of the employee",
        "NGAY_VAO_CHINH_THUC": "Official joining date",
        "TEN_HOP_DONG_EXAMPLE": "6-month employment contract",
        "TEN_HOP_DONG_NOTE": "Name of the contract type",
        "TEN_HOP_DONG": "Contract name",
        "GIO_LAM_VIEC_TRONG_NGAY_EXAMPLE": "835323….",
        "GIO_LAM_VIEC_TRONG_NGAY_NOTE": "Number of working hours per day for the employee",
        "GIO_LAM_VIEC_TRONG_NGAY": "Working hours/day by position",
        "GIO_LAM_VIEC_TRONG_TUAN_EXAMPLE": "40",
        "GIO_LAM_VIEC_TRONG_TUAN_NOTE": "Number of working hours per week for the employee",
        "GIO_LAM_VIEC_TRONG_TUAN": "Working hours/week by position",
        "BLOCK_CONG_EXAMPLE": "0.5",
        "BLOCK_CONG_NOTE": "Work unit block calculation",
        "BLOCK_CONG": "Work block",
        "THANG_EXAMPLE": "10",
        "THANG_NOTE": "Current month",
        "THANG": "Month",
        "NAM_EXAMPLE": "2022",
        "NAM_NOTE": "Current year",
        "NAM": "Year",
        "NGAY_BAT_DAU_EXAMPLE": "10/09/2021",
        "NGAY_BAT_DAU_NOTE": "Start date for work calculation in the month",
        "NGAY_BAT_DAU": "Start date",
        "NGAY_KET_THUC_EXAMPLE": "10/10/2021",
        "NGAY_KET_THUC_NOTE": "End date for work calculation",
        "NGAY_KET_THUC": "End date",
        "TONG_SO_NGAY_EXAMPLE": "31",
        "TONG_SO_NGAY_NOTE": "Total actual days",
        "TONG_SO_NGAY": "Total days",
        "TONG_SO_NGAY_CHU_NHAT_EXAMPLE": "3",
        "TONG_SO_NGAY_CHU_NHAT_NOTE": "Total Sundays in the month",
        "TONG_SO_NGAY_CHU_NHAT": "Total Sundays",
        "TONG_SO_NGAY_T2_EXAMPLE": "3",
        "TONG_SO_NGAY_T2_NOTE": "Total Mondays in the month",
        "TONG_SO_NGAY_T2": "Total Mondays",
        "TONG_SO_NGAY_T3_EXAMPLE": "3",
        "TONG_SO_NGAY_T3_NOTE": "Total Tuesdays in the month",
        "TONG_SO_NGAY_T3": "Total Tuesdays",
        "TONG_SO_NGAY_T4_EXAMPLE": "3",
        "TONG_SO_NGAY_T4_NOTE": "Total Wednesdays in the month",
        "TONG_SO_NGAY_T4": "Total Wednesdays",
        "TONG_SO_NGAY_T5_EXAMPLE": "3",
        "TONG_SO_NGAY_T5_NOTE": "Total Thursdays in the month",
        "TONG_SO_NGAY_T5": "Total Thursdays",
        "TONG_SO_NGAY_T6_EXAMPLE": "3",
        "TONG_SO_NGAY_T6_NOTE": "Total Fridays in the month",
        "TONG_SO_NGAY_T6": "Total Fridays",
        "TONG_SO_NGAY_T7_CHAN_EXAMPLE": "3",
        "TONG_SO_NGAY_T7_CHAN_NOTE": "Total even-week Saturdays in the month",
        "TONG_SO_NGAY_T7_CHAN": "Total even-week Saturdays",
        "TONG_SO_NGAY_T7_LE_EXAMPLE": "3",
        "TONG_SO_NGAY_T7_LE_NOTE": "Total odd-week Saturdays in the month",
        "TONG_SO_NGAY_T7_LE": "Total odd-week Saturdays",
        "TONG_SO_TUAN_DAY_DU_EXAMPLE": "2",
        "TONG_SO_TUAN_DAY_DU_NOTE": "Total full weeks (all days present) in the month",
        "TONG_SO_TUAN_DAY_DU": "Total full weeks",
        "TONG_SO_GIO_LAM_VIEC_EXAMPLE": "0.5",
        "TONG_SO_GIO_LAM_VIEC_NOTE": "Total working hours calculated by the system",
        "TONG_SO_GIO_LAM_VIEC": "Total working hours",
        "SO_GIO_LAM_VIEC_CA_NOTE": "Working hours per shift",
        "SO_GIO_LAM_VIEC_CA": "Working hours per shift",
        "TONG_SO_GIO_LAM_VIEC_CA_EXAMPLE": "23",
        "TONG_SO_GIO_LAM_VIEC_CA_NOTE": "Total working hours per shift",
        "TONG_SO_GIO_LAM_VIEC_CA": "Total working hours per shift",
        "CONG_LAM_VIEC_CA_NOTE": "Formula for calculating shift work attendance",
        "CONG_LE": "Holiday attendance",
        "TONG_GIO_LAM_VIEC_EXAMPLE": "23",
        "TONG_GIO_LAM_VIEC_NOTE": "Total actual working hours of an employee in the month. If an employee has split attendance records, this is the total of all records",
        "TONG_GIO_LAM_VIEC": "Total actual working hours",
        "CONG_LAM_THEM_NOTE": "Formula for calculating overtime attendance",
        "CONG_LAM_THEM_THUC_TE_NOTE": "Formula for calculating actual overtime attendance",
        "CONG_AN_CA_NOTE": "Attendance for meal shifts in the month",
        "CONG_AN_CA": "Attendance for meal shifts",
        "TIEN_PHAT_CHAM_CONG_NOTE": "Formula for calculating late arrival penalties",
        "TIEN_PHAT_CHAM_CONG": "Late attendance penalty",
        "TIEN_KHEN_THUONG_EXAMPLE": "10000000",
        "TIEN_KHEN_THUONG_NOTE": "Bonus amount received by the employee",
        "TIEN_KHEN_THUONG": "Bonus amount",
        "TIEN_VI_PHAM_EXAMPLE": "1000000",
        "TIEN_VI_PHAM_NOTE": "Amount of money the employee violated in the month",
        "TIEN_VI_PHAM": "Violation money",
        "TIEN_PHUC_LOI_EXAMPLE": "1000000",
        "TIEN_PHUC_LOI_NOTE": "Welfare money for the month",
        "TIEN_PHUC_LOI": "Welfare money",
        "PHEP_DAU_KY_NOTE": "Beginning leave balance",
        "PHEP_DAU_KY": "Beginning leave balance",
        "PHEP_DA_DUNG_NOTE": "Leave used",
        "PHEP_DA_DUNG": "Leave used",
        "PHEP_CUOI_KY_NOTE": "Ending leave balance",
        "PHEP_CUOI_KY": "Ending leave balance",
        "NGHI_BU_DAU_KY_NOTE": "Beginning compensatory leave balance",
        "NGHI_BU_DAU_KY": "Beginning compensatory leave balance",
        "NGHI_BU_DA_DUNG_NOTE": "Compensatory leave used",
        "NGHI_BU_DA_DUNG": "Compensatory leave used",
        "NGHI_BU_GIO_THEM_NOTE": "Additional compensatory leave hours",
        "NGHI_BU_GIO_THEM": "Additional compensatory leave hours",
        "NGHI_BU_CUOI_KY_NOTE": "Ending compensatory leave balance",
        "NGHI_BU_CUOI_KY": "Ending compensatory leave balance",

        //mission
        "DIA_DIEM": "Location",
        "TIEN_PHU_PHI": "Additional fee",
        "SO_GIO": "Number of hours",
        "CONG_TAC_NUOC_NGOAI_EXAMPLE": "0|1",
        "CONG_TAC_NUOC_NGOAI_NOTE": "Returns 1 for abroad, 0 for domestic",
        "CONG_TAC_NUOC_NGOAI": "Overseas business trip status",
        "LY_DO_CONG_TAC_NOTE": "Detailed reason for domestic or overseas business trip",
        "LY_DO_CONG_TAC": "Reason for overseas business trip",

        // absence
        "TU_NGAY": "From date",
        "DEN_NGAY": "To date",
        "TU_GIO": "From time",
        "DEN_GIO": "To time",
        "GIO_VANG_MAT_NOTE": "Excludes break time and irregular breaks",
        "GIO_VANG_MAT": "Number of absent hours",
        "NGAY_VANG_MAT": "Absent days",
        "LY_DO_BI_PHAT_NOTE": "Reason for absence and whether a penalty applies",
        "LY_DO_BI_PHAT": "Reason for penalty",
        "LY_DO_VANG_MAT": "Reason for absence",
        "TINH_LUONG_NOTE": "Returns 0 or 1",
        "TINH_LUONG": "Included in payroll",

        // check-in
        "THOI_GIAN_CHAM_CONG": "Check-in time",
        "LOAI_CHAM_CONG_EXAMPLE": "MACHINE|APP|GPS",
        "LOAI_CHAM_CONG_NOTE": "MACHINE: check-in from attendance machine, APP: check-in recorded from approved request, GPS: check-in recorded from mobile device",
        "LOAI_CHAM_CONG": "Check-in type",
        "LY_DO_EXAMPLE": "NO_FINGER|FAIL_MACHINE|MISSION",
        "LY_DO_NOTE": "NO_FINGER: forgot to check-in, FAIL_MACHINE: attendance machine malfunction, MISSION: working outside or business trip",
        "LY_DO": "Reason",
        "DIA_CHI_EXAMPLE": "Company headquarters, construction site",
        "DIA_CHI": "Address",
        "MAY_CHAM_CONG_ID": "Attendance machine ID"

    }

}